export interface Ordering {
  key: string | null;
  order: string | null;
}

const record: Ordering = {
  key: null,
  order: null,
};

export default record;
